import React, { useEffect, useState } from 'react'
import { Modal, Steps, Form   } from 'antd' 
import { useSKspjdListQuery } from '../../../store/DianShangYeWuApi';
function IncomeNodeCheck(props) {
    const {data, isSuccess} = useSKspjdListQuery({ddsr_spjd_qy_id:props.qy_id,ddsr_spjd_user_id:props.user_id},{skip:!props.user_id});
    const [items, setItems] = useState([]);
    const [form] = Form.useForm();
    useEffect(() => {
        if(isSuccess && data){
            if(data.Status === 'success' && data.Result){
                const newArr = data.Result.map(item => {
                    const {ddsr_spjd_id:key,ddsr_spjd_name,ddsr_spjd_yh_name,ddsr_spjd_content,ddsr_spjd_xuhao,} = item;
                    return {
                        key,
                        title: ddsr_spjd_name + '：' + ddsr_spjd_yh_name,
                        content: ddsr_spjd_content,
                        ddsr_spjd_xuhao: ddsr_spjd_xuhao,
                        status: 'wait',
                    }
                })
                const sortArr = newArr.sort( (a, b) => {
                    return a.ddsr_spjd_xuhao - b.ddsr_spjd_xuhao;
                })                    
                setItems(sortArr);
                
            } else {
                setItems([]);
            }
        }
    },[data, isSuccess, props.qy_id, props.user_id, props.ddsr_spjd_user_name])
    const [open, setOpen] = useState(false);    
    return (
        <>
            <a onClick={() => {setOpen(true)}}>{props.ddsr_spjd_user_name}</a>
            <Modal
                open={open}
                onCancel={() => setOpen(false)}
                onOk={() => {}}
                footer={null}
                width={1280}
            >
                <Form 
                    form={form} 
                    layout='horizontal' 
                    labelCol={{ span: 6 }}
                    name={`form_check_${props.ddsr_spjd_user_id}`}
                >
                    <Form.Item label="收款单操作员" >
                        {props.ddsr_spjd_user_name}
                    </Form.Item>
                    <Form.Item label="审批点">
                        <div style={{ marginTop: '30px' }}>
                            <style>
                                {`
                                    .ant-steps-item-title {
                                        color: #000 !important;
                                    }
                                `}
                            </style>
                            <Steps
                                items={items}
                                orientation="vertical"  
                                size="small"
                                current={items.length-1}
                            />
                        </div>
                    </Form.Item>                        
                </Form>
            </Modal>
        </>
    )
}
export default IncomeNodeCheck